import { useEffect } from 'react'
import "components/Accordion/styles/styles.scss";
// Components
import {
  Button,
  Input,
  SelectAutocomplete,
  SelectSimple,
} from "@components/Input";
// Assets
import { closeSvg } from "@assets";
// Vendor
import { Skeleton } from "@mui/material";
import { setDeskIdZendesk } from "components/Accordion/AccordionIntents/params/helpers/setDeskIdIfSingleDesk";
import { setDeskIdSunco } from "components/Accordion/AccordionIntents/params/helpers/setDeskIdSunco";
import { returnElementFromArray } from "vendor/application";

export const UseCustomFields = (props) => {
  const {
    i,
    intent,
    use_custom_fields,
    integrations,
    getCustomFields,
    updateIntent,
    el,
    t
  } = props;

  useEffect(() => {
    setDeskIdZendesk({
      i,
      intent,
      use_custom_fields,
      integrations,
      getCustomFields,
      updateIntent,
    });

    setDeskIdSunco({
      i,
      intent,
      use_custom_fields,
      integrations,
      getCustomFields,
      updateIntent,
    });
  }, [])
  
  const handleParameters = (e, type, i) => {
    const { intent, updateIntent, integrations } = props;

    const sunco_desk_id = integrations
      .find((int) => int.channel === "sunco")?.channel_id;

    const zendesk_ticket_field = {
      id: e.id,
      type: e.type,
      title: e.title,
      equivalences: [],
      desk_id: intent.parameters[i]?.zendesk_ticket_field?.desk_id || sunco_desk_id,
      custom_field_options: e.custom_field_options || [],
      custom_field_options_actual: e.custom_field_options
        ? [...e.custom_field_options]
        : [],
    };

    intent.parameters[i].zendesk_ticket_field = zendesk_ticket_field;
    updateIntent(intent);
  };

  const deleteTicketField = (i) => {
    const { intent, updateIntent, getCustomFields } = props;
    const newParameters = [...intent.parameters];
    const desk_id = newParameters[i]?.zendesk_ticket_field?.desk_id;
    newParameters[i].zendesk_ticket_field = null;
    updateIntent({ ...intent, parameters: newParameters });
    if (desk_id) {
      getCustomFields("zendesk", desk_id, intent);
    }
  };

  const addParameterEquivalence = (i) => {
    const { intent, updateIntent } = props;
    intent.parameters[i].zendesk_ticket_field.equivalences.push({
      text: "",
      value: "",
      title: "",
    });
    updateIntent(intent);
  };

  const updateParameterEquivalence = (e, parameter, equivalence) => {
    const { intent, updateIntent } = props;
    intent.parameters[parameter].zendesk_ticket_field.equivalences[
      equivalence
    ].text = e.target.value;
    updateIntent(intent);
  };

  const selectParameterEquivalence = (e, type, i) => {
    const { intent, updateIntent } = props;
    var equivalences =
        intent.parameters[i[0]].zendesk_ticket_field.equivalences,
      all_custom_field =
        intent.parameters[i[0]].zendesk_ticket_field.custom_field_options,
      actual_custom_field =
        intent.parameters[i[0]].zendesk_ticket_field
          .custom_field_options_actual;

    if (equivalences[i[1]].value) {
      var element = returnElementFromArray(
        equivalences[i[1]].value,
        all_custom_field,
        "value"
      );
      actual_custom_field.push(element);
    }

    equivalences[i[1]].value = e.value;
    equivalences[i[1]].title = e.name;

    actual_custom_field.map((custom, ii) => {
      if (custom.value === e.value) {
        actual_custom_field.splice(ii, 1);
      }
    });

    intent.parameters[i[0]].zendesk_ticket_field.custom_field_options_actual =
      actual_custom_field;

    updateIntent(intent);
  };

  const deleteParameterEquivalence = (parameter, equivalence) => {
    const { intent, updateIntent } = props;
    var equivalences =
        intent.parameters[parameter].zendesk_ticket_field.equivalences,
      all_custom_field =
        intent.parameters[parameter].zendesk_ticket_field.custom_field_options,
      actual_custom_field =
        intent.parameters[parameter].zendesk_ticket_field
          .custom_field_options_actual;

    if (equivalences[equivalence].value) {
      var element = returnElementFromArray(
        equivalences[equivalence].value,
        all_custom_field,
        "value"
      );
      actual_custom_field.push(element);
    }

    equivalences.splice(equivalence, 1);
    updateIntent(intent);
  };

  const handleSelector = () => {
    const { integrations } = props;
    if (integrations.length > 0) {
      const integration = integrations?.filter(
        (int) => int.channel === "zendesk_full"
      )[0];
      var use_custom = integration?.multiple.filter(
        (int) => int.use_custom_fields
      );
      if (use_custom?.length === 1) {
        return false;
      }
      if (use_custom?.length > 1) {
        return true;
      }
    }
    return false;
  };

  const updateDeskId = (e) => {
    const { el, i, intent, use_custom_fields, getCustomFields, updateIntent } =
      props;
    if (e !== el?.zendesk_ticket_field?.desk_id) {
      intent.parameters[i].zendesk_ticket_field = { desk_id: e };
      updateIntent(intent);

      if (!use_custom_fields || !use_custom_fields[e]) {
        getCustomFields("zendesk", e, intent, true);
      }
    }
  };

  function getDeskId() {
    const { integrations } = props;
    const channels = ["sunco", "zendesk_full"];
    for (const channel of channels) {
      const integration = integrations?.find((int) => int.channel === channel);
      if (integration) {
        return integration.id;
      }
    }
    return null;
  }

  const integration = integrations.filter(
    (int) => int.channel === "zendesk_full"
  )[0];
  const sunco_integration = integrations.filter(
    (int) => int.channel === "sunco"
  )[0];

  const sunco_desk_id = sunco_integration?.channel_id;

  const desk_id = (el && el?.zendesk_ticket_field?.desk_id) || sunco_desk_id;
  const zendesk_options = use_custom_fields?.[desk_id];
  const has_zendesk = zendesk_options?.length > 0;
  const zendesk_options_title_map = zendesk_options?.map((option) => {
    return {
      ...option,
      title: `${option.title} ${
        option.regexp_for_validation
          ? `(${option.regexp_for_validation})`
          : ""
      }`,
    };
  });
  var desk_name = "-";
  if (el.zendesk_ticket_field && el.zendesk_ticket_field.desk_id) {
    desk_name = integration?.multiple?.filter(
      (int) => int.id === el.zendesk_ticket_field.desk_id
    )[0]?.name;
  }
  if (use_custom_fields) {
    const deskId = el?.zendesk_ticket_field?.desk_id;

    if (deskId && use_custom_fields[deskId]) {
      const lengthCheck = use_custom_fields[deskId]?.length > 0;
    }
  }
  const integration_sunco = integrations?.filter(
    (int) => int.channel === "sunco"
  )[0];
  const customActive =
    integration_sunco?.info?.zendesk?.use_custom_fields?.active;

  if (
    customActive &&
    (!zendesk_options_title_map || zendesk_options_title_map.length === 0)
  ) {
    return (
      <div className={"info__integration_content_skeleton"}>
        <Skeleton variant="rectangular" width="100%" height={10} />
        <Skeleton variant="rectangular" width="100%" height={40} />
      </div>
    );
  }

  return (
        <> 
            {handleSelector() && (
              <div className={"accordion__element_use_custom_fields"}>
                <SelectSimple
                  valueSelected={desk_name}
                  items={integration.multiple}
                  label={t("common:intents.integrations.desk_id")}
                  onSelect={(e) =>{
                    updateDeskId(e);
                  }}
                  placeholder={t("common:intents.integrations.desk_id")}
                  value={"id"}
                  className={"select_secondary nodrag"}
                  t={t}
                />
              </div>
            )}
            {has_zendesk && (
              <div className={"accordion__element_use_custom_fields"}>
                <div className={"actions"}>
                  <SelectAutocomplete
                    value={
                      el.zendesk_ticket_field ? el.zendesk_ticket_field : false
                    }
                    searchOption={"title"}
                    items={zendesk_options_title_map || []}
                    className={"select_secondary nodrag"}
                    onSelect={handleParameters}
                    placeholder={t(
                      "intents.config.accordion.params.zendesk_custom_field.custom_field"
                    )}
                    iteration={i}
                    t={t}
                  />
                  <Button
                    className={"btn_icon"}
                    type={"white"}
                    onClick={() => {
                      deleteTicketField(i);
                    }}
                    text={closeSvg()}
                  />
                </div>
                {el.zendesk_ticket_field?.custom_field_options?.length > 0 &&
                  el.zendesk_ticket_field?.type === "tagger" && (
                    <>
                      <Button
                        disabled={
                          el.zendesk_ticket_field.equivalences.length ===
                          el.zendesk_ticket_field.custom_field_options.length
                        }
                        type={"dashed"}
                        onClick={() => {
                          addParameterEquivalence(i);
                        }}
                        text={t(
                          "intents.config.accordion.params.zendesk_custom_field.add_button"
                        )}
                      />
                      {el.zendesk_ticket_field.equivalences.map(
                        (equivalence, ii) => {
                          return (
                            <div
                              className={"accordion__element_parameter_equivalence"}
                              key={ii}
                            >
                              <Input
                                id={`equivalences-${ii}`}
                                onChange={(e) => {
                                  updateParameterEquivalence(e, i, ii);
                                }}
                                value={equivalence.text}
                                placeholder={t(
                                  "intents.config.accordion.params.zendesk_custom_field.text"
                                )}
                              />
                              <SelectSimple
                                valueSelected={
                                  equivalence.title ? equivalence.title : false
                                }
                                items={
                                  el.zendesk_ticket_field
                                    .custom_field_options_actual
                                }
                                className={"select_secondary nodrag"}
                                onSelect={selectParameterEquivalence}
                                placeholder={t(
                                  "intents.config.accordion.params.zendesk_custom_field.value"
                                )}
                                iteration={[i, ii]}
                                t={t}
                              />
                              <div
                                onClick={() => {
                                  deleteParameterEquivalence(i, ii)
                                }
                                }
                                className={"delete_equivalence"}
                              >
                                {closeSvg()}
                              </div>
                            </div>
                          );
                        }
                      )}
                    </>
                  )}
              </div>
            )}
          </>
  )
}